import React from "react";
import { FaTimes } from "react-icons/fa";
import { useLanguage } from "../../components/LanguageContext";
import { ClickToPath, Language } from "../../Types/types";
import { panoramainputstranslation } from "./tPanoramaInputs";

interface PanoramaInputsProps {
  clickToPaths: ClickToPath[];
  setClickToPaths: (paths: ClickToPath[]) => void;
  links: { targetPackageContentId: number; label: string }[];
}

const PanoramaInputs: React.FC<PanoramaInputsProps> = ({
  clickToPaths,
  setClickToPaths,
  links,
}) => {
  const { language } = useLanguage();
  const t = panoramainputstranslation[language as Language];

  const handleAddClickToPath = () => {
    setClickToPaths([
      ...clickToPaths,
      { path: "", angle: 0, targetPackageContentId: undefined },
    ]);
  };

  const handleClickToPathChange = (
    index: number,
    field: string,
    value: string | number
  ) => {
    const updatedPaths = [...clickToPaths];
    if (field === "path") {
      const selectedLink = links.find(
        (link) => link.targetPackageContentId === Number(value)
      );
      updatedPaths[index] = {
        ...updatedPaths[index],
        [field.toString()]: value,
        targetPackageContentId: selectedLink?.targetPackageContentId,
      };
    } else {
      updatedPaths[index] = { ...updatedPaths[index], [field]: value };
    }
    setClickToPaths(updatedPaths);
  };

  const handleRemoveClickToPath = (index: number) => {
    const updatedPaths = clickToPaths.filter((_, i) => i !== index);
    setClickToPaths(updatedPaths);
  };

  return (
    <div className="mb-2 relative dark:text-white">
      {clickToPaths.length > 0 && (
        <div className="grid grid-cols-2 gap-2">
          <div className="block text-base ml-2">{t.redirectTo}</div>
          <div className="block text-base ml-2">{t.angle}</div>
        </div>
      )}
      {clickToPaths.map((clickToPath, index) => (
        <div key={index} className="mt-2 grid grid-cols-2 gap-2">
          <div className="">
            <select
              className="w-full bg-white px-2 py-4.5 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-0 dark:border-purple dark:bg-darkBackground"
              value={clickToPath.path}
              onChange={(e) =>
                handleClickToPathChange(index, "path", e.target.value)
              }
            >
              <option value="" disabled>
                {t.selectPath}
              </option>
              {links.map((link) => (
                <option
                  key={link.targetPackageContentId}
                  value={link.targetPackageContentId}
                >
                  {link.label}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="w-full bg-white px-[6px] py-6.5 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-0 dark:border-purple dark:bg-darkBackground"
              value={clickToPath.angle || ""}
              onChange={(e) =>
                handleClickToPathChange(
                  index,
                  "angle",
                  e.target.value === "" ? 0 : Number(e.target.value)
                )
              }
            />
            <button
              type="button"
              className="text-red-500"
              onClick={() => handleRemoveClickToPath(index)}
            >
              <FaTimes className="text-red-500" />
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        className="mt-4 bg-purple text-white px-4 py-2 rounded font-medium shadow-sm"
        onClick={handleAddClickToPath}
      >
        {t.addRedirect}
      </button>
    </div>
  );
};

export default PanoramaInputs;
